/**
 * websocket接收消息后的对应的字段管理类
 */
export default class WebSocketMessageOption {
  command;
  data;
  code;
  msg;
  errorHandlerMap;

  /**
   * 构造函数
   * @param command<String> websocket接收JSON消息后command的字段名
   * @param data<String>    websocket接收JSON消息后data的字段名
   */
  constructor (
    errorHandlerMap = {},
    command = 'command',
    data = 'data',
    code = 'code',
    msg = 'msg'
  ) {
    this.command = command
    this.data = data
    this.code = code
    this.msg = msg
    this.errorHandlerMap = errorHandlerMap
  }
}



// WEBPACK FOOTER //
// ./src/utils/WebSocket/WebSocketMessageOpt.js